module.exports = __webpack_public_path__ + "img/sysm.681c4a56.svg";